// extracted by mini-css-extract-plugin
export default {"CarouselBlock":"JMP1Xcvnhj7hKkMjAv6m","Arrow":"CZjTkllQnf9iXi1xxGsU","PrevArrow":"YYKC4YYN7DvrHM4AG9ln","NextArrow":"djLgW5QOpositjMXnQpj"};